{% block ecocode_trustpilot_business_unit_config %}
    <div>
        <sw-single-select
            deprecated
            class="sw-import-export-edit-profile-modal__object-type-select"
            :label="$tc('ecocode-trustpilot.config.businessUnitLabel')"
            required
            v-bind="$attrs"
            name="useCustomTemplates"
            :options="businessUnitOptions"
            @update:value="triggerChange"
            v-model:value="currentValue.businessUnit">
        </sw-single-select>
        <sw-switch-field
            deprecated
            :label="$tc('ecocode-trustpilot.config.showCustomTemplatesLabel')"
            v-model:value="currentValue.useCustomTemplates"
            @update:value="triggerChange"
            name="useCustomTemplates"
            v-bind="$attrs"
            v-if="currentValue.businessUnit">
        </sw-switch-field>
        <ecocode-trustpilot-invitation-template-select
            v-for="[locale,value] in Object.entries(templatesList)"
            :locale="locale"
            :key="locale"
            :name="locale"
            type="ServiceReview"
            :label="$tc('ecocode-trustpilot.config.templateLabel', {locale}, {locale})"
            :disabled="$attrs.disabled"
            v-if="currentValue.useCustomTemplates"
            :businessUnit="currentValue.businessUnit"
            @update:value="triggerChange"
            v-model:value="currentValue.templates[locale]">
        </ecocode-trustpilot-invitation-template-select>
        <ecocode-trustpilot-invitation-template-select
            v-for="[locale,value] in Object.entries(productTemplatesList)"
            :locale="locale"
            :name="locale"
            type="ProductReview"
            :label="$tc('ecocode-trustpilot.config.productTemplateLabel',{locale}, {locale})"
            :key="locale"
            :disabled="$attrs.disabled"
            v-if="(currentValue.useCustomTemplates && productInvitationState)"
            :businessUnit="currentValue.businessUnit"
            @update:value="triggerChange"
            v-model:value="currentValue.productTemplates[locale]">
        </ecocode-trustpilot-invitation-template-select>
    </div>
{% endblock %}
